<!-- ======= Top Bar ======= -->
<div id="topbar" class="d-none d-lg-flex align-items-center fixed-top">
    <div class="container d-flex">
        <div class="contact-info mr-auto">
            <i class="icofont-email"></i> <a
                href="mailto:info@hawktrading.com">info@hawktrading.com </a>
                 <i class="icofont-phone"></i>   +94 11 429 4747 / 4748
        </div>
        <div class="social-links">
            <!-- <a href="#" class="twitter"><i class="icofont-twitter"></i></a> -->
            <a href="https://www.facebook.com/doksinternational" class="facebook"><i class="icofont-facebook"></i></a>
            <a href="https://instagram.com/doksinternational?utm_medium=copy_link" class="instagram"><i class="icofont-instagram"></i></a>
            <!-- <a href="#" class="skype"><i class="icofont-skype"></i></a> -->
            <!-- <a href="#" class="linkedin"><i class="icofont-linkedin"></i> </a> -->
        </div>
    </div>
</div>
